import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-little-dot",
  "use": "icon-little-dot-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-little-dot\"><path d=\"M512 512m-160 0a160 160 0 1 0 320 0 160 160 0 1 0-320 0Z\" p-id=\"13920\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol